
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/retrieve-data",
      function () {
        return require("private-next-pages/retrieve-data.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/retrieve-data"])
      });
    }
  